(() => {
  const boxes = () => [...document.querySelectorAll('[data-clc-coupon]')];
  const normalized = code => String(code || '').trim().toUpperCase();
  const root = () => window.Shopify?.routes?.root || '/';
  let confirmed = [];
  let confirmedCart;
  let known = false;
  let busy = false;
  let removing = "";
  let active;
  let revision = 0;
  let interrupted = false;

  function buttonState(button, applied, pending) {
    const label = applied ? 'Aplicado' : pending ? 'Aplicando…' : 'Aplicar';
    if (button.dataset.clcState !== label) {
      button.replaceChildren();
      if (applied) {
        const svg = document.createElementNS('http://www.w3.org/2000/svg', 'svg');
        svg.setAttribute('viewBox', '0 0 20 20');
        svg.setAttribute('aria-hidden', 'true');
        svg.setAttribute('focusable', 'false');
        const path = document.createElementNS('http://www.w3.org/2000/svg', 'path');
        path.setAttribute('d', 'm4 10 4 4 8-8');
        svg.append(path);
        button.append(svg);
      }
      const text = document.createElement('span');
      text.textContent = label;
      button.append(text);
      button.dataset.clcState = label;
    }
    button.disabled = busy;
    button.setAttribute('aria-disabled', String(busy || applied));
    const code = button.dataset.clcCode;
    button.setAttribute('aria-label', (applied ? 'Cupón aplicado' : pending ? 'Aplicando cupón' : 'Aplicar cupón') + (code ? ' ' + code : ''));
  }

  function removalControl(button, code) {
    let remove = button.nextElementSibling;
    if (!remove?.matches('[data-clc-remove]')) {
      remove = document.createElement('button');
      remove.type = 'button';
      remove.dataset.clcRemove = '';
      const svg = document.createElementNS('http://www.w3.org/2000/svg', 'svg');
      svg.setAttribute('viewBox', '0 0 20 20');
      svg.setAttribute('aria-hidden', 'true');
      const path = document.createElementNS('http://www.w3.org/2000/svg', 'path');
      path.setAttribute('d', 'm6 6 8 8m0-8-8 8');
      svg.append(path);
      remove.append(svg);
      button.after(remove);
    }
    remove.dataset.clcRemove = code || '';
    remove.hidden = !code;
    remove.disabled = busy;
    remove.title = 'Quitar cupón';
    remove.setAttribute('aria-label', 'Quitar cupón' + (code ? ' ' + code : ''));
  }

  async function clikeaRemoveCoupon(box, code) {
    if (busy || !code) return;
    active?.abort();
    revision++;
    const controller = new AbortController();
    active = controller;
    busy = true;
    removing = normalized(code);
    boxes().forEach(render);
    const timer = setTimeout(() => controller.abort(), 15000);
    try {
      const freshResponse = await fetch(root() + 'cart.js', {credentials:'same-origin',cache:'no-store',signal:controller.signal,headers:{Accept:'application/json'}});
      if (!freshResponse.ok) throw new Error('No pudimos quitar el cupón. Inténtalo de nuevo.');
      let cart = await freshResponse.json();
      if (!Array.isArray(cart.discount_codes)) throw new Error('No pudimos comprobar los cupones. Actualiza el carrito.');
      const keep = cart.discount_codes.filter(entry => normalized(entry.code) !== removing).map(entry => entry.code).filter(Boolean);
      if (cart.discount_codes.some(entry => normalized(entry.code) === removing)) {
        const response = await fetch(root() + 'cart/update.js', {
          method:'POST',credentials:'same-origin',signal:controller.signal,
          headers:{'Content-Type':'application/json',Accept:'application/json'},
          body:JSON.stringify({discount:keep.join(',')})
        });
        if (!response.ok) throw new Error('No pudimos quitar el cupón. Inténtalo de nuevo.');
        cart = await response.json();
      }
      if (!Array.isArray(cart.discount_codes) || cart.discount_codes.some(entry => normalized(entry.code) === removing)) throw new Error('El cupón sigue aplicado. Inténtalo de nuevo.');
      cart = couponCartSnapshot(cart);
      synchronize(cart);
      const app = window.Alpine?.$data(document.documentElement);
      if (typeof app?.updateCart === 'function') await app.updateCart(false, cart);
      if (!known || confirmed.includes(removing)) throw new Error('El cupón sigue aplicado. Inténtalo de nuevo.');
      boxes().forEach(other => {
        const input = other.querySelector('input');
        if (normalized(input.value) === removing) input.value = '';
        const list = other.querySelector('.clc-coupon__available');
        if (list) list.open = false;
        const manual = other.querySelector('.clc-coupon__manual');
        if (manual && !confirmed.length) manual.open = false;
        const status = other.querySelector('[role=status]');
        status.textContent = 'Cupón quitado. Puedes elegir otro.';
        status.dataset.state = 'removed';
      });
      (box.dataset.clcApplied === 'true' ? box.querySelector('[data-clc-applied-compact]') : box.querySelector('.clc-coupon__manual > summary')).focus({preventScroll:true});
    } catch (error) {
      if (controller.signal.aborted) {
        known = false;
        confirmed = [];
        interrupted = true;
      }
      boxes().forEach(other => {
        const status = other.querySelector('[role=status]');
        status.textContent = controller.signal.aborted ? 'No pudimos confirmar el cambio. Actualiza el carrito para comprobarlo.' : error.message;
        status.dataset.state = 'error';
      });
    } finally {
      clearTimeout(timer);
      busy = false;
      removing = '';
      if (active === controller) active = null;
      boxes().forEach(render);
      if (known && !confirmed.includes(normalized(code))) (box.dataset.clcApplied === 'true' ? box.querySelector('[data-clc-applied-compact]') : box.querySelector('.clc-coupon__manual > summary')).focus({preventScroll:true});
    }
  }

  function couponCartSnapshot(cart) {
    if (!Array.isArray(cart?.discount_codes) || !Array.isArray(cart.items) ||
        !['item_count','total_price','original_total_price','total_discount'].every(key => Number.isFinite(cart[key])) ||
        !Array.isArray(cart.cart_level_discount_applications)) {
      throw new Error('No pudimos confirmar los importes. Actualiza el carrito para comprobarlos.');
    }
    return {
      ...cart,
      cart_level_discount_applications: cart.cart_level_discount_applications.map(entry => {
        if (!entry.discount_application) return entry;
        const application = entry.discount_application;
        return {...application, total_allocated_amount: application.total_allocated_amount ?? entry.amount};
      })
    };
  }

  function couponSaving(code) {
    if (!confirmedCart || !code) return 0;
    let amount = 0;
    const cartApplications = (confirmedCart.cart_level_discount_applications || []).filter(application => normalized(application.code || application.title) === code);
    for (const item of confirmedCart.items || []) {
      const allocations = Array.isArray(item.line_level_discount_allocations) ? item.line_level_discount_allocations : cartApplications.length ? [] : item.discounts || [];
      for (const allocation of allocations) {
        const application = allocation.discount_application || allocation;
        if (normalized(application.code || application.title) === code) amount += Number(allocation.amount) || 0;
      }
    }
    for (const application of cartApplications) amount += Number(application.total_allocated_amount) || 0;
    return amount;
  }

  function renderCompactCoupon(box, code) {
    const panel = box.querySelector('[data-clc-applied-compact]');
    if (!panel) return;
    panel.hidden = !code;
    panel.querySelector('[data-clc-coupon-code]').textContent = code || '';
    const saving = couponSaving(code);
    const amount = panel.querySelector('[data-clc-coupon-savings]');
    amount.hidden = !saving;
    amount.textContent = saving ? box.dataset.clcSavingsLabel + ' ' + Shopify.formatMoney(saving, true) : '';
    const remove = panel.querySelector('[data-clc-remove]');
    remove.dataset.clcRemove = code || '';
    remove.hidden = !code;
    remove.disabled = busy;
    remove.title = 'Quitar cupón';
    remove.setAttribute('aria-label', 'Quitar cupón' + (code ? ' ' + code : ''));
  }

  function render(box) {
    const input = box.querySelector('input');
    const applied = known && confirmed.includes(normalized(input.value));
    const manual = box.querySelector('.clc-coupon__manual');
    if (manual && known && confirmed.length) manual.open = true;
    input.readOnly = busy;
    box.setAttribute('aria-busy', String(busy));
    box.dataset.clcApplied = String(known && confirmed.length > 0);
    buttonState(box.querySelector('[data-clc-apply]'), applied, busy && !removing);
    removalControl(box.querySelector('[data-clc-apply]'), known ? (applied ? normalized(input.value) : confirmed[0]) : '');
    renderCompactCoupon(box, known ? (applied ? normalized(input.value) : confirmed[0]) : '');
    box.querySelectorAll('[data-clc-code]').forEach(button => {
      buttonState(button, known && confirmed.includes(normalized(button.dataset.clcCode)), busy && !removing && normalized(input.value) === normalized(button.dataset.clcCode));
      removalControl(button, known && confirmed.includes(normalized(button.dataset.clcCode)) ? normalized(button.dataset.clcCode) : "");
    });
    const status = box.querySelector('[role=status]');
    if (busy) {
      status.textContent = removing ? 'Quitando cupón…' : 'Aplicando cupón…';
      status.dataset.state = 'pending';
    } else if (applied && status.dataset.state !== 'error') {
      status.textContent = 'Cupón aplicado. ¡Tu ahorro ya está en el total!';
      status.dataset.state = 'applied';
    } else if (status.dataset.state === 'applied' || status.dataset.state === 'pending') {
      status.textContent = 'El descuento se reflejará en el total cuando el código sea válido.';
      status.dataset.state = '';
    }
  }

  function synchronize(cart, fillEmpty = false) {
    if (!Array.isArray(cart?.discount_codes)) return;
    revision++;
    const previous = confirmed;
    known = true;
    confirmedCart = cart;
    confirmed = cart.discount_codes.filter(entry => entry.applicable === true).map(entry => normalized(entry.code)).filter(Boolean);
    boxes().forEach(box => {
      const input = box.querySelector('input');
      if (fillEmpty && !input.value.trim() && confirmed[0]) input.value = confirmed[0];
      render(box);
      if (previous.includes(normalized(input.value)) && !confirmed.includes(normalized(input.value))) {
        const status = box.querySelector('[role=status]');
        status.textContent = 'Este cupón ya no está aplicado. Revisa las condiciones de tu carrito.';
        status.dataset.state = 'error';
      }
      if (confirmed.length && !previous.length) {
        const list = box.querySelector('.clc-coupon__available');
        if (list) list.open = false;
      }
    });
  }

  async function readState() {
    if (busy || document.hidden || !boxes().length) return;
    active?.abort();
    const controller = new AbortController();
    active = controller;
    const current = ++revision;
    const timer = setTimeout(() => controller.abort(), 15000);
    try {
      const response = await fetch(root() + 'cart.js', {credentials:'same-origin', cache:'no-store', signal:controller.signal, headers:{Accept:'application/json'}});
      if (!response.ok) throw new Error('Cart unavailable');
      const cart = await response.json();
      if (revision === current) synchronize(cart, true);
    } catch {
      interrupted = true;
    } finally {
      clearTimeout(timer);
      if (active === controller) active = null;
    }
  }

  async function clikeaApplyCoupon(box, code, trigger) {
    const cleanCode = String(code || '').trim();
    const status = box.querySelector('[role=status]');
    if (busy) return;
    if (!cleanCode) {
      status.textContent = 'Escribe un código para aplicarlo.';
      status.dataset.state = 'error';
      box.querySelector('input').focus();
      return;
    }
    if (known && confirmed.includes(normalized(cleanCode))) return;
    active?.abort();
    revision++;
    const controller = new AbortController();
    active = controller;
    busy = true;
    boxes().forEach(other => {other.querySelector('input').value = cleanCode; render(other);});
    const timer = setTimeout(() => controller.abort(), 15000);
    try {
      const response = await fetch(root() + 'cart/update.js', {
        method:'POST', credentials:'same-origin', signal:controller.signal,
        headers:{'Content-Type':'application/json', Accept:'application/json'},
        body:JSON.stringify({discount:cleanCode})
      });
      if (!response.ok) throw new Error('No pudimos aplicar el cupón. Inténtalo de nuevo.');
      const cart = couponCartSnapshot(await response.json());
      synchronize(cart);
      const app = window.Alpine?.$data(document.documentElement);
      if (typeof app?.updateCart === 'function') await app.updateCart(false, cart);
      if (!known || !confirmed.includes(normalized(cleanCode))) {
        throw new Error('El código no se aplicó a este carrito. Revisa su vigencia y condiciones.');
      }
      boxes().forEach(other => {
        const list = other.querySelector('.clc-coupon__available');
        if (list) list.open = false;
      });
      try { sessionStorage.setItem('clikeaCouponPeekPlayed', '1'); } catch {}
    } catch (error) {
      if (controller.signal.aborted) {
        known = false;
        confirmed = [];
        interrupted = true;
      }
      boxes().forEach(other => {
        const message = other.querySelector('[role=status]');
        message.textContent = controller.signal.aborted ? 'No pudimos confirmar el cupón. Actualiza el carrito para comprobarlo.' : error.message;
        message.dataset.state = 'error';
      });
    } finally {
      clearTimeout(timer);
      busy = false;
      if (active === controller) active = null;
      boxes().forEach(render);
      if (known && confirmed.includes(normalized(cleanCode))) (box.dataset.clcApplied === 'true' ? box.querySelector('[data-clc-applied-compact]') : box.querySelector('.clc-coupon__manual > summary')).focus({preventScroll:true});
    }
  }

  document.addEventListener('toggle', event => {
    if (event.target.matches?.('.clc-coupon__manual') && event.target.closest('[data-clc-coupon]')?.dataset.clcApplied === 'true') event.target.open = true;
  },true);
  document.addEventListener('click', event => {
    const remove = event.target.closest('[data-clc-remove]');
    if (remove) {
      const box = remove.closest('[data-clc-coupon]');
      if (box) void clikeaRemoveCoupon(box, remove.dataset.clcRemove);
      return;
    }
    const button = event.target.closest('[data-clc-code], [data-clc-apply]');
    if (!button) return;
    const box = button.closest('[data-clc-coupon]');
    if (box) void clikeaApplyCoupon(box, button.dataset.clcCode || box.querySelector('input').value, button);
  });
  document.addEventListener('input', event => {
    if (!event.target.matches('[data-clc-coupon] input')) return;
    const box = event.target.closest('[data-clc-coupon]');
    box.querySelector('[role=status]').dataset.state = 'pending';
    render(box);
  });
  document.addEventListener('keydown', event => {
    if (event.key !== 'Enter' || !event.target.matches('[data-clc-coupon] input')) return;
    event.preventDefault();
    event.target.closest('[data-clc-coupon]').querySelector('[data-clc-apply]').click();
  });
  window.addEventListener('clikea:cart-updated', event => synchronize(event.detail, true));
  window.addEventListener('pageshow', event => {if (event.persisted) void readState();});
  document.addEventListener('visibilitychange', () => {
    if (document.hidden) {interrupted = Boolean(active); active?.abort();}
    else if (interrupted) {interrupted = false; void readState();}
  });
  function initialize() {
    boxes().forEach(render);
    if (!known) void readState();
    const teasers = document.querySelectorAll('[data-clc-coupon-peek]');
    if (!teasers.length || !('IntersectionObserver' in window) || window.matchMedia('(prefers-reduced-motion: reduce)').matches) return;
    try {if (sessionStorage.getItem('clikeaCouponPeekPlayed') === '1') return;} catch {}
    const observer = new IntersectionObserver(entries => {
      const visible = entries.find(entry => entry.isIntersecting);
      if (!visible) return;
      visible.target.classList.add('is-revealed');
      observer.disconnect();
      try {sessionStorage.setItem('clikeaCouponPeekPlayed', '1');} catch {}
    }, {threshold:0.65});
    teasers.forEach(teaser => observer.observe(teaser));
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', initialize, {once:true});
  else initialize();
})();
